module.exports = __webpack_public_path__ + "img/banner1.4c088e50.png";